import styled from 'styled-components';
import { Button } from '@sravni/react-design-system';
import { color, fonts, width } from '../../constants';

export const Wrapper = styled.div`
    position: relative;
    display: block;
    width: 100%;
    background: var(--color-background);
    border-bottom: 1px solid ${color.greyLight};
    padding: 100px 0 120px;

    @media (max-width: ${width.mobile}) {
        box-sizing: border-box;
        padding: 100px 45px 120px;
    }
`;

export const Image = styled.img`
    position: relative;
    display: block;
    margin: 0 auto;
    width: 172px;
`;

export const Headline = styled.div`
    position: relative;
    display: block;
    font-family: ${fonts.ubuntu};
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: ${color.greyDark};
    text-align: center;
    padding: 30px 0 10px;
`;

export const Text = styled.div`
    font-size: 14px;
    line-height: 20px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
`;

export const SelectButton = styled(Button)`
    width: 220px;
    margin: 20px auto 0;
    display: block;
`;
